export class AbonementView {
	constructor() {
		this.$firstStadium = $("#js-first-stadium svg");
		this.$secondStadium = $("#js-second-stadium svg");

		this.$priceTable = $("#js-abonement-price-table");
		this.$priceViewItem = $(".js-abonement-price-view");
	}
}
